<span [style]="textStyle" [style.color]="colorStyle" (click)="clicked()">
  <ng-content></ng-content>
</span>